// Utilitaire de slugification pour URLs SEO-friendly
// "Location Bétonnière" -> "location-betonniere"
// "Location Barnums & Tentes" -> "location-barnums-tentes"

export const slugify = (str) => {
  if (!str) return '';
  return str
    .toString()
    .normalize('NFD')                 // décompose les accents (é -> e + ´)
    .replace(/[\u0300-\u036f]/g, '')  // supprime les diacritiques
    .toLowerCase()
    .trim()
    .replace(/&/g, 'et')              // & -> "et"
    .replace(/[^a-z0-9]+/g, '-')      // tout ce qui n'est pas alphanum -> -
    .replace(/^-+|-+$/g, '')          // supprime les - en début/fin
    .replace(/-+/g, '-');             // dédoublonne les ---
};

// Détecte si une URL provient de l'ancien format (%20, %C3, +)
// pour redirection 301 côté frontend
export const isLegacySubcategoryUrl = (urlSegment) => {
  if (!urlSegment) return false;
  return urlSegment.includes('%') || urlSegment.includes('+') || /[A-Z]/.test(urlSegment);
};

// Construit une Map { slug: subcategoryName } depuis une liste de produits
// Permet de retrouver le nom original à partir du slug dans l'URL
export const buildSubcategorySlugMap = (products) => {
  const map = {};
  for (const p of products || []) {
    if (p.subcategory) {
      map[slugify(p.subcategory)] = p.subcategory;
    }
  }
  return map;
};
